import { useMemo, useState } from "react";
import * as R from "ramda";

export const blankState = {
  isModalOpen: false,
  isSelectionActive: false,
  isOverlayActive: false,
};

/* Actions */

const activateSelection = (state) => {
  //console.log("--->State action: activateSelection");
  return {
    ...state,
    isSelectionActive: true,
  };
};

const deactivateSelection = (state) => {
  //console.log("--->State action: deactivateSelection");
  return {
    ...state,
    isSelectionActive: false,
  };
};

const activateOverlay = (state) => {
  //console.log("--->State action: activateOverlay");
  return {
    ...state,
    isOverlayActive: true,
  };
};

const deactivateOverlay = (state) => {
  //console.log("--->State action: deactivateOverlay");
  return {
    ...state,
    isOverlayActive: false,
  };
};

const openModalWithSelection = (state) => {
  //console.log("--->State action: openModalWithSelection");
  return {
    ...state,
    isModalOpen: true,
    isSelectionActive: true,
  };
};

const openModalWithOverlay = (state) => {
  //console.log("--->State action: openModalWithOverlay");
  return {
    ...state,
    isModalOpen: true,
    isOverlayActive: true,
  };
};

const closeModal = (state) => {
  //console.log("--->State action: closeModal");
  return {
    ...state,
    isModalOpen: false,
    isSelectionActive: false,
    isOverlayActive: false,
  };
};

/* Action handlers */

const actionHandlers = {
  activateOverlay,
  deactivateOverlay,
  activateSelection,
  deactivateSelection,
  openModalWithSelection,
  openModalWithOverlay,
  closeModal,
};

/**
 * useAnnotationState
 * the actionHandlers should be functions with `state` as the last argument.
 * The generated `actions` map decorates the handlers to accept the first arguments,
 * then adds the state as the last argument to update the state.
 * eg. actions.activateSelection() will update the state by calling activateSelection(prevState)
 * @param  {Object} initialState blankState (above) plus any modifications from loaded data
 * @return {Array} [state, actions] where actions is a keyed object that looks
 *                 just like actionHandlers
 *
 */
export function useAnnotationState(initialState) {
  const [state, setState] = useState(initialState);

  const actions = useMemo(
    () =>
      R.mapObjIndexed((fn, key) => (...args) => {
        setState((prevState) => {
          const nextState = fn(...args, prevState);
          // console.log("action", key, args);
          return nextState;
        });
      })(actionHandlers),
    [],
  );

  return [state, actions];
}
